import axios from 'axios'
import Settings from '@/custom/classes/settings.js'
import { getInternalAuthToken } from '@/custom/classes/my_utils.js'

const settings = new Settings()

// Default config for the axios instance
const axiosParams = {
  // Set different base URL based on the environment
  baseURL: settings.get({ path: 'base_api_url' })
}

// Create axios instance with default params
const axiosInstance = axios.create(axiosParams)

// Main api function
const api = axios => {
  // Wrapper functions around axios
  return {
    get: (url, config = {}) => axios.get(url, config),
    post: (url, body, config = {}) => axios.post(url, body, config),
    patch: (url, body, config = {}) => axios.patch(url, body, config),
    delete: (url, config = {}) => axios.delete(url, config)
  }
}

/**
 * Generate header function for custom calls
 *
 * @param {string} headerType - choose relevant header
 */
export const generateRequestHeader = headerType => {
  // Default headers per request
  const defaultHeader = {
    accept: 'shared api; version=1',
    Authorization: getInternalAuthToken(),
    ADMINREQUEST: getInternalAuthToken()
  }
  // Modify header based on its type
  switch (headerType) {
    case 'applicant':
      return { ...defaultHeader, accept: 'applicant api; version=1' }
    case 'company':
      return { ...defaultHeader, accept: 'company api; version=1' }
    case 'admin':
      return { ...defaultHeader, accept: 'admin api; version=1' }
    case 'public':
      return { ...defaultHeader, accept: 'public api; version=1' }
    default:
      return { ...defaultHeader }
  }
}

// Initialise the api function and pass axiosInstance to it
export default api(axiosInstance)
